<template>
    <div class="btn-box">
        <el-button class="btn luyin" @click="aiRecord">AI语音合成</el-button>
        <Roles
            v-if="isXunfei"
            ref="roles"
            :is-content="true"
            :is-file-name="true"
            :visible.sync="isXunfei"
            :selectRole.sync="selectRole"
            :defaultValue="config"
            @onXunfei="onXunfei"
        />
    </div>
</template>

<script>
    import {mapActions} from 'vuex'
    import BMF from 'browser-md5-file'
    import Roles from '../../../../../../../../components/VoiceConfig/components/roles'
    import {upLoad, getFileStream} from "../../../../../../../../utils/upload";
    import * as commonServer from '../../../../../../../../api/common'

    export default {
        name: "luyin-ai-btn",
        components: {
            Roles
        },
        props: {
            isShop: {
                type: Boolean,
                default: false
            },
        },
        computed: {
            addResource(){
                return this.isShop?'addResourceShop':'addResource'
            }
        },
        watch: {
            isXunfei(state) {
                if(state){
                    this.setSendKeyBoardToCocos({key: 'isXunfei', value: false})
                }else{
                    this.setSendKeyBoardToCocos({key: 'isXunfei', value: true})
                }
            },
        },
        data(){
            return {
                isXunfei: false,
                selectRole: 0,
                config: {},
                audioUrl: '', // 音频地址
            }
        },
        methods: {
            ...mapActions(['setSendKeyBoardToCocos']),
            aiRecord(){
                this.config = {}
                this.isXunfei = true
            },
            onFlash () {
                this.$emit('onFlash')
            },
            onXunfei(obj){
                if (!obj.url) return false
                this.uploadAudio({url: obj.url, type: 'ai', name: obj.fileName})
            },
            // 将远端地址转成文件流上传
            uploadAudio({url, type, name}) {
                // 将合成音频上传至音频素材
                // 1.将远端地址转成文件流
                // 2.将文件流上传到腾讯云
                // 3.上传合成音频到素材
                getFileStream({url, name, callback: (blob)=>{
                        const bmf = new BMF()
                        bmf.md5(blob, (err, md5)=>{
                            upLoad({isPlat: this.isShop, fileName: `${md5}.mp3`, file: blob, callback: async url=>{
                                    let newName = type === 'wx'?'微信':'合成'+'音频' + md5.slice(0,3)
                                    if(name) {
                                        newName = name
                                    }
                                    // 上传音频文件到素材列表
                                    let newUrl = this.$utils.getHtmlMd5(url)
                                    const remotepath = url.split('.com/')[1]
                                    let obj = {
                                        clientsId: this.$store.state.initConfig.school_id,
                                        sort: 'audio',
                                        name: newName,
                                        alias: '',
                                        attributes: {
                                            cover: url,
                                            remotepath,
                                            md5: newUrl.indexOf('.') > -1?newUrl.split('.')[0] : newUrl
                                        }
                                    }
                                    if(`${this.categoryId}` !== `0`) obj.categoryId = this.categoryId

                                    const res = await commonServer.default[this.addResource](obj)
                                    if (`${res.status_code}` === '200') {
                                        this.$message.success('上传成功')
                                        this.$refs.roles && this.$refs.roles.handleClose()
                                        this.$emit('onFlash')
                                    } else {
                                        // this.$message.error('上传失败')
                                    }

                                }})
                        })

                    }})
            },
        }
    }
</script>

<style lang="scss" scoped>
.btn-box {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-bottom: 10px;
    /*margin: 40px 0px;*/
    width: 100%;

    height:40px;
    background:rgba(255, 120, 56,1);
    border-radius:4px;
}
.luyin {
    /*background-color: #fed800;*/
    width: 100%;
    background:#e7622e !important;
    border: none;
    outline: none;
    font-size: 18px;
    height: 40px;
    color: white !important;
    border-radius: 20px;

    &:hover,&:active{
        opacity: .8;
    }
}
</style>
